"use strict";
/** @module config/twoPartTransitionWords */
/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */

module.exports = function () {
  return [["both", "and"], ["if", "then"], ["not only", "but also"], ["neither", "nor"], ["either", "or"], ["not", "but"], ["whether", "or"], ["no sooner", "than"]];
};
//# sourceMappingURL=twoPartTransitionWords.js.map
//# sourceMappingURL=twoPartTransitionWords.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/english/twoPartTransitionWords.js
// module id = 410
// module chunks = 0